import React, { useContext, useEffect, useState} from 'react';
import { useDealer } from '../../../../hooks/useDealer'
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css'
import Select from 'react-select';
import { selectStyle } from './selectStyle';
import ModalTransactions from '../ModalTransactions/ModalTransactions';
import ModalCars from '../ModalCars/ModalCars';
 
const List = () => { 
  const {appState, app} = useContext(AppContext);

  const salers = appState.salers.map((user) => ({ 
    value: user.id, 
    label: user.firstname + " " + user.lastname 
  }));

  const { dealerService } = useDealer(5); 
 
  useEffect( ()=> {
    dealerService.fetchList()
  }, [])
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    dealerService.setFilter({
      ...dealerService.filter,
      [name]: value
    });
  };
 
 
  return <div>

    <div className={ cl.headMain }> 
        <h1>დილერები</h1>   
        <Add dealerService={dealerService} /> 
    </div>
 
    <div className={tbl.table + ' ' + cl.table}>
 
      <table>
        <thead>
            <tr>
            <th className={cl.id} >#</th>
            <th className={ cl.pad0 }>
                <input name="firstname"  placeholder="სახელი გვარი" value={dealerService.filter.firstname} onChange={handleInputChange} /> 
            </th>
            <th className={ cl.pad0 }>
                <input name="email" placeholder="ელ-ფოსტა" value={dealerService.filter.email}  onChange={handleInputChange} />
            </th>
            <th className={ cl.pad0 }>
                <input  name="mobile" placeholder="მობილური" value={dealerService.filter.mobile} onChange={handleInputChange} />
            </th>
            <th className={ cl.pad0 }>
                <input name="personal" placeholder="პურადი ნომერი" value={dealerService.filter.personal}  onChange={handleInputChange} />
            </th>
            <th className={ cl.pad0 }> 
                    <Select
                    styles={selectStyle}
                    options={salers}  
                    value={salers.find(option => option.value === dealerService.filter.saler_id)}
                    onChange={(selectedOption) => {
                      dealerService.setFilter(prevState => ({
                          ...prevState,
                          saler_id: selectedOption ? selectedOption.value : 0,
                        }));
                      }}
                      isClearable
                    placeholder="სელერი"
                  />  
            </th>


            <th>  </th> 
            </tr>
        </thead>
        <tbody>
            {dealerService.items.map((item) =>
              <tr key={item.id} >
                <td className={cl.id} >{item.id} </td>
                <td>{item.firstname}  {item.lastname}</td>
                <td>{item.email}</td>
                <td>{item.mobile}</td>
                <td>{item.personal}</td>
                <td>{item?.saler?.firstname} {item?.saler?.lastname}</td>
      
                <td className={ cl.btntbl }>
                    <div className={ cl.btns }>
                        <Edit dealerService={dealerService} defaultDealer={item}/>
                        <Delete dealerService={dealerService} defaultDealer={item}/>
                    </div>
                </td>

                
              </tr>  
              
            )}
        </tbody>
      </table>

 
    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={dealerService.total} 
                perPage={dealerService.filter.limit} 
                current={dealerService.filter.page} 
                paginate={(page) => {
                  dealerService.setFilter({
                    ...dealerService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                  dealerService.setFilter({
                    ...dealerService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default List;